@if (message) {
    <div style="word-wrap: break-word">
        <div [ngClass]="'alert alert-' + status!">{{ message }}</div>
    </div>
}
